export enum Teardown {
  CREATE_1 = 'create-1',
  CREATE_2 = 'create-2',
  CREATE_3 = 'create-3',
  CREATE_4 = 'create-4',
  INVITE_1 = 'invite-1',
  INVITE_2 = 'invite-2',
}

export enum TestSelector {
  AUTHENTICATION_EMAIL_PASSWORD_BUTTON = 'authentication-email-password-button',
  AUTHENTICATION_MICROSOFT_BUTTON = 'authentication-microsoft-button',
  AUTHENTICATION_SIGNIN_EMAIL_PASSWORD_ERROR = 'authentication-signin-email-password-error',
  AUTHENTICATION_SIGNIN_MICROSOFT_NOACCOUNT_ERROR = 'authentication-microsoft-noaccount-error',
  AUTHENTICATION_SIGNUP_EMAIL_SUBMIT_BUTTON = 'authentication-signup-email-submit-button',
  AUTHENTICATION_SIGNUP_USER_SUBMIT_BUTTON = 'authentication-signup-user-submit-button',
  AUTHENTICATION_SIGNUP_COMPANY_SUBMIT_BUTTON = 'authentication-signup-company-submit-button',
  AUTHENTICATION_SIGNUP_FIELD_COUNTRY = 'authentication-signup-field-country',
  AUTHENTICATION_SIGNUP_FIELD_PSA = 'authentication-signup-field-psa',
  AUTHENTICATION_SIGNUP_CREATE_ACCOUNT_BUTTON = 'authentication-signup-create-account-button',
  AUTHENTICATION_SIGNUP_CANCEL_BUTTON = 'authentication-signup-cancel-button',
  AUTHENTICATION_SIGNUP_ALREADY_REGISTERED_ERROR = 'authentication-signup-already-registered-error',
  /* ICON SVG SELECTORS */
  UI_ICON_LOADER = 'ui-icon-loader',
  UI_ICON_MICROSOFT_SIGNIN = 'ui-icon-microsoft-signin',
  UI_ICON_MICROSOFT_SIGNUP = 'ui-icon-microsoft-signup',
  /* END ICON SVG SELECTORS */
  USER_PROFILE_INITIALS = 'user-profile-initials',
  FIELD_EMAIL_ERROR = 'field-email-error',
  FIELD_PASSWORD_ERROR = 'field-password-error',
}
